(function () {
    'use strict';

    angular.module("imApp").factory("orderToConsignmentsService", [function () {
        let service = {};

        return service;
    }]);
})();
